import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/OrganizerManagement';

function* getListEventOrganizerManagement(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/organizer/`;
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                body: {
                    ...action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.GetListEventOfOrganizerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetListEventOfOrganizerRequestedReceivedFailure(yield error));
    }
}
function* getDetailOrganizerManagement(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/organizer/${action.payload.company_id}/`;
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailOfOrganizerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailtOfOrganizerRequestedReceivedFailure(yield error));
    }
}

function* approveOrganizer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post, {
                endpoint: '/api/v1/user/approve_register/',
                body: {
                    user_id: action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.ApproveRegisterRequestedReveived(response));
    } catch (error) {
        yield put(Actions.ApproveRegisterRequestedReveivedFailure(yield error));
    }
}

function* rejectOrganizer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post, {
                endpoint: '/api/v1/user/reject_register/',
                body: {
                    user_id: action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.RejectRegisterRequestedReveived(response));
    } catch (error) {
        yield put(Actions.RejectRegisterRequestedReveivedFailure(yield error));
    }
}
function* sendInvoice(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post, {
                endpoint: '/api/v1/user/receipt/',
                body: {
                    company_id: action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.SendInvoiceRequestedReveived(response));
    } catch (error) {
        yield put(Actions.SendInvoiceRequestedReveivedFailure(yield error));
    }
}

function* getCsvOrganizer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.shortName}/download-csv-organizer/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetCsvOrganizerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetCsvOrganizerReceiveFailure(yield error));
    }
}

export default function* login() {
    yield all([
        takeLatest('GET_LIST_EVENT_OF_ORGANIZER_REQUESTED', getListEventOrganizerManagement),
        takeLatest('GET_DETAIL_OF_ORGANIZER_REQUESTED', getDetailOrganizerManagement),
        takeLatest('APPROVE_REGISTER_REQUESTED', approveOrganizer),
        takeLatest('REJECT_REGISTER_REQUESTED', rejectOrganizer),
        takeLatest('SEND_INVOICE_REQUESTED', sendInvoice),
        takeLatest('GET_CSV_ORGANIZER_REQUESTED', getCsvOrganizer),
    ]);
}
